import React from "react";
import "./PageLayoutStyle.scss";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PageFooter from "components/PageFooter";

const PageLayout = () => {
  return (
    <div className="page-layout">
      <Header />
      <Outlet />
      <PageFooter />
      {/* <Footer /> */}
    </div>
  );
};

export default PageLayout;
